import { useHomeBanner, useOctoDapAiCampusHub, useOctoDapAiCampusHubDynamic } from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';
import WorkflowCard from '@/components/workflowCard';

const ITechMarkingWizardView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: octoDapAiCampusHub } = useOctoDapAiCampusHub(language);
    const { data: octoDapAiCampusHubDynamic } = useOctoDapAiCampusHubDynamic(language);
    let octoDapAiCampusHubData = octoDapAiCampusHub?.data || {};
    let octoDapAiCampusHubDynamicData = octoDapAiCampusHubDynamic?.data || {};
    
    return (
        <>
            <main className='theme-orange-gradient' id="start">
                <Banner banner={banner} category="OctoDAP AI Campus Hub" />
                <Card cardData={octoDapAiCampusHubData?.Cards?.Cards || []} cardType="white-card" />
                <WorkflowCard workflowdata={octoDapAiCampusHubData?.CommonAgenticWorkflow} language={language} />
                {/* DynamicContent */}
                <DynamicContent content={octoDapAiCampusHubDynamicData?.Content} />
            </main>
        </>
    );
}

export default ITechMarkingWizardView;